import { SubscriptionListInput, SubscriptionsResponse } from '../types/subscription.types';
import http from '../utils/http-common';

const getSubscriptions = (data: SubscriptionListInput) => {
  return http.post<SubscriptionsResponse>('/admin/stripe/subscription/get-all', data);
};

const SubscriptionService = {
  getSubscriptions,
};

export default SubscriptionService;
